<template>
    <div class="card rounded-c-3 shadow border-0 mt-4">
        <form @submit.prevent="register" enctype="multipart/form-data">
            <div class="card-body px-c-5 pt-4 pb-5">
                <div class="col-12">
                    <div class="form-group mt-4 mb-2">
                        <label for="name" class="form-label">
                            <i class="fas fa-user text-c-primary me-1"></i>
                            {{ localise("tour_form", "name") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="name"
                            name="name"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.name.$error ? 'is-invalid' : ''"
                            v-model="name"
                        />
                        <div v-if="v$.name.minLength" class="invalid-feedback">
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="phone" class="form-label">
                            <i class="fas fa-phone-alt text-c-primary me-1"></i>
                            {{ localise("tour_form", "phone") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.phone.$error ? 'is-invalid' : ''"
                            v-model="phone"
                        />
                        <div v-if="v$.phone.$error" class="invalid-feedback">
                            {{ localise("validation", "phone") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="email" class="form-label">
                            <i class="fas fa-envelope text-c-primary me-1"></i>
                            {{ localise("tour_form", "email") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.email.$error ? 'is-invalid' : ''"
                            v-model="email"
                        />
                        <div v-if="v$.email.$error" class="invalid-feedback">
                            {{ localise("validation", "email") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="birthday" class="form-label">
                            <i
                                class="fas fa-calendar-day text-c-primary me-1"
                            ></i>
                            {{ localise("hiking_festival", "birthday") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="birthday"
                            name="birthday"
                            type="date"
                            class="form-control py-3 rounded-c-3"
                            max="2006-07-20"
                            :class="v$.birthday.$error ? 'is-invalid' : ''"
                            v-model="birthday"
                        />
                        <div v-if="v$.birthday.$error" class="invalid-feedback">
                            {{ localise("validation", "required_field") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="country" class="form-label">
                            <i class="fas fa-globe text-c-primary me-1"></i>
                            {{ localise("hiking_festival", "country") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="country"
                            name="country"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.country.$error ? 'is-invalid' : ''"
                            v-model="country"
                        />
                        <div v-if="v$.country.$error" class="invalid-feedback">
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="city" class="form-label">
                            <i
                                class="fas fa-map-marker-alt text-c-primary me-1"
                            ></i>
                            {{ localise("hiking_festival", "city") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="city"
                            name="city"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.city.$error ? 'is-invalid' : ''"
                            v-model="city"
                        />
                        <div v-if="v$.city.$error" class="invalid-feedback">
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="current_city" class="form-label">
                            <i class="fas fa-map-pin text-c-primary me-1"></i>
                            {{ localise("hiking_festival", "current_city") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="current_city"
                            name="current_city"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.current_city.$error ? 'is-invalid' : ''"
                            v-model="current_city"
                        />
                        <div
                            v-if="v$.current_city.$error"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="passport" class="form-label">
                            <i class="fas fa-id-card text-c-primary me-1"></i>
                            {{ localise("hiking_festival", "passport") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="passport"
                            name="passport"
                            type="file"
                            class="form-control rounded-c-3"
                            accept="image/*"
                            :class="v$.passport.$error ? 'is-invalid' : ''"
                            @change="(e) => handlePassport(e)"
                        />
                        <div v-if="v$.passport.$error" class="invalid-feedback">
                            {{ localise("validation", "required_field") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="distance_while_hiking" class="form-label">
                            <i class="fas fa-route text-c-primary me-1"></i>
                            {{
                                localise(
                                    "hiking_festival",
                                    "distance_while_hiking"
                                )
                            }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="distance_while_hiking"
                            name="distance_while_hiking"
                            type="number"
                            min="1"
                            class="form-control py-3 rounded-c-3"
                            :class="
                                v$.distance_while_hiking.$error
                                    ? 'is-invalid'
                                    : ''
                            "
                            v-model="distance_while_hiking"
                        />
                        <div
                            v-if="v$.distance_while_hiking.$error"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "required_field") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <i class="fas fa-hiking text-c-primary me-1"></i>
                        {{
                            localise("hiking_festival", "has_hiking_experience")
                        }}
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="has_hiking_experience1"
                                    v-model="has_hiking_experience"
                                    :value="true"
                                />
                                <label
                                    class="form-check-label"
                                    for="has_hiking_experience1"
                                >
                                    {{ localise("hiking_festival", "yes") }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="has_hiking_experience2"
                                    v-model="has_hiking_experience"
                                    :value="false"
                                />
                                <label
                                    class="form-check-label"
                                    for="has_hiking_experience2"
                                >
                                    {{ localise("hiking_festival", "no") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <i class="fas fa-campground text-c-primary me-1"></i>
                        {{
                            localise("hiking_festival", "has_hiking_equipments")
                        }}
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="has_hiking_equipments1"
                                    v-model="has_hiking_equipments"
                                    :value="true"
                                />
                                <label
                                    class="form-check-label"
                                    for="has_hiking_equipments1"
                                >
                                    {{ localise("hiking_festival", "yes") }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="has_hiking_equipments2"
                                    v-model="has_hiking_equipments"
                                    :value="false"
                                />
                                <label
                                    class="form-check-label"
                                    for="has_hiking_equipments2"
                                >
                                    {{ localise("hiking_festival", "no") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <i class="fas fa-user-friends text-c-primary me-1"></i>
                        {{ localise("hiking_festival", "is_with_partner") }}
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="is_with_partner1"
                                    v-model="is_with_partner"
                                    :value="true"
                                />
                                <label
                                    class="form-check-label"
                                    for="is_with_partner1"
                                >
                                    {{ localise("hiking_festival", "yes") }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="is_with_partner2"
                                    v-model="is_with_partner"
                                    :value="false"
                                />
                                <label
                                    class="form-check-label"
                                    for="is_with_partner2"
                                >
                                    {{ localise("hiking_festival", "no") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="is_with_partner" class="form-group mt-4 mb-2">
                        <label for="partner_name" class="form-label">
                            <i class="fas fa-user text-c-primary me-1"></i>
                            {{ localise("hiking_festival", "partner_name") }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <input
                            id="partner_name"
                            name="partner_name"
                            type="text"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.partner_name.$error ? 'is-invalid' : ''"
                            v-model="partner_name"
                        />
                        <div
                            v-if="v$.partner_name.$error"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "min5") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <i class="fas fa-pills text-c-primary me-1"></i>
                        {{ localise("hiking_festival", "gets_medicaments") }}
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="gets_medicaments1"
                                    v-model="gets_medicaments"
                                    :value="true"
                                />
                                <label
                                    class="form-check-label"
                                    for="gets_medicaments1"
                                >
                                    {{ localise("hiking_festival", "yes") }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="gets_medicaments2"
                                    v-model="gets_medicaments"
                                    :value="false"
                                />
                                <label
                                    class="form-check-label"
                                    for="gets_medicaments2"
                                >
                                    {{ localise("hiking_festival", "no") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="where_did_you_find_us" class="form-label">
                            <i class="fas fa-bullseye text-c-primary me-1"></i>
                            {{
                                localise(
                                    "hiking_festival",
                                    "where_did_you_find_us"
                                )
                            }}
                            <span class="text-danger ms-1">*</span>
                        </label>
                        <select
                            id="where_did_you_find_us"
                            name="where_did_you_find_us"
                            class="form-select py-3 rounded-c-3"
                            :class="
                                v$.where_did_you_find_us.$error
                                    ? 'is-invalid'
                                    : ''
                            "
                            v-model="where_did_you_find_us"
                        >
                            <option value="" selected>
                                {{ localise("hiking_festival", "choose") }}
                            </option>
                            <option value="friend">
                                {{ localise("hiking_festival", "friend") }}
                            </option>
                            <option value="social">
                                {{ localise("hiking_festival", "social") }}
                            </option>
                            <option value="google">
                                {{ localise("hiking_festival", "google") }}
                            </option>
                            <option value="other">
                                {{ localise("hiking_festival", "other") }}
                            </option>
                        </select>
                        <div
                            v-if="v$.where_did_you_find_us.$error"
                            class="invalid-feedback"
                        >
                            {{ localise("validation", "required_field") }}
                        </div>
                    </div>
                    <div class="form-group mt-4 mb-2">
                        <label for="about" class="form-label">
                            <i
                                class="fas fa-info-circle text-c-primary me-1"
                            ></i>
                            {{ localise("hiking_festival", "about") }}
                        </label>
                        <textarea
                            rows="3"
                            cols="10"
                            id="about"
                            name="about"
                            type="number"
                            class="form-control py-3 rounded-c-3"
                            :class="v$.about.$error ? 'is-invalid' : ''"
                            v-model="about"
                        ></textarea>
                        <div v-if="v$.about.$error" class="invalid-feedback">
                            {{ localise("validation", "min20") }}
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button
                            v-if="!$store.state.loading"
                            type="submit"
                            class="btn btn-lg btn-c-secondary rounded-c-3 px-5 py-4 fs-6 text-white shadow mt-4 w-100"
                        >
                            {{ localise("tour_form", "button") }}
                            <i class="fas fa-check-circle ms-1"></i>
                        </button>
                        <div
                            v-else
                            class="spinner-grow text-dark mt-3"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import translations from "../../helpers/translations";
import {
    fileUpload,
    hikingFestRegister,
} from "../../services/InternalApiService";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";

export default {
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            name: "",
            phone: "",
            email: "",
            birthday: "",
            country: "",
            city: "",
            current_city: "",
            passport: null,
            distance_while_hiking: "",
            where_did_you_find_us: "",
            about: "",
            gets_medicaments: false,
            has_hiking_experience: false,
            has_hiking_equipments: false,
            is_with_partner: false,
            partner_name: null,
        };
    },
    validations() {
        return {
            name: { required, minLength: minLength(5) },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            email: { required, email },
            birthday: { required },
            country: { required, minLength: minLength(5) },
            city: { required, minLength: minLength(5) },
            current_city: { required, minLength: minLength(5) },
            passport: { required },
            distance_while_hiking: { required },
            where_did_you_find_us: { required },
            about: {},
            partner_name: this.is_with_partner ? { required } : {},
        };
    },
    methods: {
        register() {
            this.v$.$validate();
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.state.loading = true;
                setTimeout(() => {
                    hikingFestRegister({
                        name: this.name,
                        phone: this.phone,
                        email: this.email,
                        birthday: this.birthday,
                        country: this.country,
                        city: this.city,
                        current_city: this.current_city,
                        passport: this.passport,
                        distance_while_hiking: this.distance_while_hiking,
                        where_did_you_find_us: this.where_did_you_find_us,
                        about: this.about,
                        gets_medicaments: this.gets_medicaments,
                        has_hiking_experience: this.has_hiking_experience,
                        has_hiking_equipments: this.has_hiking_equipments,
                        is_with_partner: this.is_with_partner,
                        partner_name: this.partner_name,
                    })
                        .then((res) => {
                            if (res.status === 201) {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: this.localise(
                                        "hiking_festival",
                                        "registration_success"
                                    ),
                                    showConfirmButton: false,
                                    timer: 3000,
                                });
                                this.clearInputs();
                                this.$store.state.loading = false;
                                return;
                            }

                            throw new Error("Something went wrong.");
                        })
                        .catch((error) => {
                            this.$store.state.loading = false;
                            console.log(error);
                            Swal.fire({
                                position: "center",
                                icon: "warning",
                                title: this.localise("validation", "error"),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        });
                }, 0);
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: this.localise("validation", "error"),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        clearInputs() {
            this.name = "";
            this.phone = "";
            this.email = "";
            this.birthday = "";
            this.country = "";
            this.city = "";
            this.current_city = "";
            this.passport = null;
            this.distance_while_hiking = "";
            this.where_did_you_find_us = "";
            this.about = "";
            this.gets_medicaments = false;
            this.has_hiking_experience = false;
            this.has_hiking_equipments = false;
            this.is_with_partner = false;
            this.partner_name = null;

            this.v$.$reset();
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
        handlePassport(e) {
            const passport = e.target.files[0];
            const formData = new FormData();
            formData.append("passport", passport);

            this.$store.state.loading = true;
            fileUpload(formData)
                .then((res) => {
                    if (res.status === 201) {
                        this.passport = res.data.file;
                        this.$store.state.loading = false;
                        return;
                    }

                    throw new Error("Something went wrong.");
                })
                .catch((error) => {
                    this.$store.state.loading = false;
                    console.log(error);
                    Swal.fire({
                        position: "center",
                        icon: "warning",
                        title: this.localise(
                            "hiking_festival",
                            "file_size_limit"
                        ),
                        showConfirmButton: false,
                        timer: 2000,
                    });
                });
        },
    },
};
</script>
